<template>
    <div class="fullPage">
        <img src="../../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--第三方收退费查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('thirdPartyCharge.thirdPartyChargeSearch')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--估价单号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('thirdPartyCharge.estimateNo')}}
                                </span>
                                <el-input v-model="estimateNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--箱号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('thirdPartyCharge.containerNo')}}
                                </span>
                                <el-input v-model="containerNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--堆场代码-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('thirdPartyCharge.depotCode')}}
                                </span>
                                <el-input v-model="depotCode"
                                          :placeholder="$t('common.pleaseEnter')"
                                          clearable/>
                            </div>
                            <!--创建时间从-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('thirdPartyCharge.crateTimeStart')}}
                                </span>
                                <el-date-picker v-model="search.createTimeStart" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--创建时间到-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t('thirdPartyCharge.crateTimeEnd')}}
                                </span>
                                <el-date-picker v-model="search.createTimeEnd" type="date" class="dateInput"
                                                :placeholder="$t('common.pleaseSelectDate')"/>
                            </div>
                            <div class="inputName">
                            </div>
                            <div class="inputName">
                            </div>
                            <div class="searchBtn">
                                <el-button type="primary" icon="el-icon-search"
                                           @click="searchBtnClick">
                                    {{searchButton}}
                                </el-button>
                                <el-button icon="el-icon-refresh"
                                           @click="resetBtnClick">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="contentListCom">
                <result-bar>
                    <div slot="resultRight">
                        <!--第三方收退费导入-->
                        <el-button icon="el-icon-folder-add" @click="customerChargeExcelImport()">
                            {{$t('thirdPartyCharge.customerChargeExcelImport')}}
                        </el-button>
                        <vxe-switch v-model="showViewFlag" style="margin-left: 5px"
                                    open-label="common.cardView" close-label="common.tableView"
                                    open-icon="el-icon-notebook-2" close-icon="vxe-icon-table"
                                    open-value="card" close-value="table" @change="handleViewStyle">
                        </vxe-switch>
                    </div>
                </result-bar>
                <!--无数据组件-->
                <div v-if="showNoDataView || tableCustomerChargeData.length === 0" class="noData">
                    <no-data-view/>
                </div>

                <!--查询结果-->
                <div class="contentListCom" v-else>
                    <!--卡片视图-->
                    <div class="oneContent" v-for="(data,index) in tableCustomerChargeData" :key="index" v-if="showViewFlag==='card'">
                        <template>
                            <div class="center flexDiv">
                                <el-descriptions style="margin-left: 10px" size="medium" :column=5 :title="index+1+'. '+$t('thirdPartyCharge.estimateNo')+': '+data.estimateNo">
                                    <!--箱号-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.containerNo')"><span class="blueColor">{{data.containerNo}}</span></el-descriptions-item>
                                    <!--堆场代码-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.depotCode')">
                                        <el-tag size="small">{{data.depotCode}}</el-tag>
                                    </el-descriptions-item>
                                    <!--发送方代码-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.senderCode')">
                                        <el-tag size="small" type="success">{{data.senderCode}}</el-tag>
                                    </el-descriptions-item>
                                    <!--创建时间-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.createdDtmLoc')">{{data.createdDtmLoc}}</el-descriptions-item>
                                    <!--收费日期-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.receiveDate')">{{data.receiveDate}}</el-descriptions-item>
                                    <!--收费金额-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.receiveAmount')">{{data.receiveAmount}}</el-descriptions-item>
                                    <!--币种-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.currency')">{{data.currency}}</el-descriptions-item>
                                    <!--退费日期-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.refundDate')">{{data.refundDate}}</el-descriptions-item>
                                    <!--退费金额-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.refundAmount')">{{data.refundAmount}}</el-descriptions-item>
                                    <!--实际金额-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.actualAmount')">{{data.actualAmount}}</el-descriptions-item>
                                    <!--收退费说明-->
                                    <el-descriptions-item :label="$t('thirdPartyCharge.remark')">{{data.remark}}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </template>
                    </div>
                    <!--第三方收退费数据表格pagination分页条-->
                    <div class="pagination" v-if="showViewFlag==='card'">
                        <div>
                            <el-pagination background layout="total,sizes,slot,prev, pager, next"
                                           max-height="600"
                                           :page-size="pageSize" :pager-count="pageCount"
                                           :page-sizes="[10, 20, 50, 100, 200]" :total="total"
                                           :current-page="pageNum"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"/>
                        </div>
                    </div>

                    <!--表格视图-->
                    <div class="mainTable" v-if="showViewFlag==='table'">
                        <vxe-grid show-overflow
                                  ref="tableCustomerChargeData" class="vxeTable"
                                  height="500" size="small"
                                  :row-config="{isCurrent: true, isHover: true}"
                                  :column-config="{resizable: true}"
                                  :export-config="{}"
                                  :checkbox-config="{checkStrictly: true}"
                                  resizable
                                  keep-source
                                  show-footer
                                  :data="tableCustomerChargeData"
                                  :columns="tableColumn"
                                  :toolbar-config="tableToolbar">
                            <!--顶部工具栏插槽-->
                            <template #toolbar_buttons>
                                <vxe-button @click="exportDataEvent" status="primary" type="text" icon="vxe-icon-file-excel" style="margin-left: 10px">
                                    {{exportDataButton}}</vxe-button>
                            </template>
                            <!--估价单号插槽-->
                            <template #column_estimateNo="{ row }">
                                <span class="secondSpan blueColor">{{row.estimateNo}}</span>
                            </template>
                            <!--箱号插槽-->
                            <template #column_containerNo="{ row }">
                                <el-tag size="mini" type="primary">{{row.containerNo}}</el-tag>
                            </template>
                            <!--堆场代码插槽-->
                            <template #column_depotCode="{ row }">
                                <el-tag size="mini" class="blue_tag">{{row.depotCode}}</el-tag>
                            </template>
                            <!--发送方代码插槽-->
                            <template #column_senderCode="{ row }">
                                <el-tag size="mini" type="success">{{row.senderCode}}</el-tag>
                            </template>
                            <template #pager>
                                <vxe-pager
                                        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                                        :current-page.sync="pageNum"
                                        :page-size.sync="pageSize"
                                        :page-sizes="[10, 20, 50, 100, 200]"
                                        :total="total"
                                        @page-change="handleTablePageChange">
                                </vxe-pager>
                            </template>
                        </vxe-grid>
                    </div>
                </div>
            </div>
        </div>

        <!--第三方收退费上传弹框-->
        <el-dialog
                :visible.sync="customerChargeUploadShow"
                width="830px" top="5%"
                :before-close="handleClose">
            <div slot="title" class="flex flex-align">
                <i class="el-icon-upload">{{$t('thirdPartyCharge.customerChargeUpload')}}</i>
            </div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('thirdPartyCharge.uploadTips')}}</div>
            <div class="el-upload__tip" style="color:#BC1920;margin-top: 10px;margin-bottom: 10px">{{$t('estimate.uploadTips')}}</div>
            <el-upload style="width: 100%"
                    class="my-upload-demo"
                    drag multipart
                    ref="customerChargeUpload"
                    :on-success="uploadSuccess"
                    action="" :limit="5"
                    accept=".xls,.xlsx"
                    :http-request="handleUpload"
                    :file-list="fileList"
                    :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('common.dragUploadTips1')}}<em>{{$t('common.dragUploadTips2')}}</em></div>
            </el-upload>
            <el-button style="margin-left: 10px;margin-top: 10px" size="small" type="success" icon="el-icon-upload2"
                       @click="uploadFile">{{$t('estimate.uploadFiles')}}</el-button>
            <el-link type="primary" style="font-size: 12px;margin-left: 10px" icon="el-icon-download"
                     href="/static/thirdChargeImportTemplate.xls" download="THIRD_PARTY_CHARGES_IMPORT_TEMPLATE.xls">{{$t('common.excelTemplateDL')}}</el-link>
            <el-table v-show="validationInfoShow" :data="tableImportValidation" style="width:100%;margin-top:10px"
                      :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                      :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                      max-height="250" highlight-current-row
                      :empty-text="$t('common.noData')">
                <!--导入结果-->
                <el-table-column min-width="240" prop="validateInfo"
                                 :label="$t('thirdPartyCharge.validateInfo')"
                                 align="center">
                    <template slot-scope="scope">
                        <span class="blueColor" v-if="scope.row.validateInfo == null || scope.row.validateInfo === ''">{{$t('common.validateSucceed')}}</span>
                        <span class="redColor" v-else>{{scope.row.validateInfo}}</span>
                    </template>
                </el-table-column>
                <!--估价单号-->
                <el-table-column min-width="120" prop="estimateNo"
                                 :label="$t('thirdPartyCharge.estimateNo')"
                                 align="center"></el-table-column>
                <!--收费日期-->
                <el-table-column min-width="100" prop="receiveDate"
                                 :label="$t('thirdPartyCharge.receiveDate')"
                                 align="center">
                </el-table-column>
                <!--发送方代码-->
                <el-table-column min-width="90" prop="senderCode"
                                 :label="$t('thirdPartyCharge.senderCode')"
                                 align="center"></el-table-column>
                <!--收费金额-->
                <el-table-column min-width="100" prop="receiveAmount"
                                 :label="$t('thirdPartyCharge.receiveAmount')"
                                 align="center"></el-table-column>
                <!--币种-->
                <el-table-column min-width="60" prop="currency"
                                 :label="$t('thirdPartyCharge.currency')"
                                 align="center"></el-table-column>
                <!--退费金额-->
                <el-table-column min-width="100" prop="refundAmount"
                                 :label="$t('thirdPartyCharge.refundAmount')"
                                 align="center"></el-table-column>
                <!--收退费说明-->
                <el-table-column min-width="200" prop="remark"
                                 :label="$t('thirdPartyCharge.remark')"
                                 align="center"></el-table-column>
            </el-table>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    import noDataView from "@/components/noDataView";
    import resultBar from "@/components/resultBar";

    export default {
        name: "thirdPartyCharge",
        computed: {
            // 估价单号查询条件
            estimateNo: {
                get: function () {
                    return this.search.estimateNo;
                },
                set: function (val) {
                    this.search.estimateNo = val.toUpperCase();
                }
            },
            // 箱号查询条件
            containerNo: {
                get: function () {
                    return this.search.containerNo;
                },
                set: function (val) {
                    this.search.containerNo = val.toUpperCase();
                }
            },
            // 堆场查询条件
            depotCode: {
                get: function () {
                    return this.search.depotCode;
                },
                set: function (val) {
                    this.search.depotCode = val.toUpperCase();
                }
            },
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            editButton() {//编辑按钮
                return this.$t("common.editButton");
            },
            exportDataButton() {
                return this.$t('common.exportTableData');
            },
            detailButton() {
                return this.$t('common.detail')
            },
        },
        components: {
            noDataView,
            resultBar
        },
        data() {
            return {
                isSearchClick: false,       //控制查询按钮是否重复点击
                customerChargeUploadShow: false,  //控制第三方收退费excel上传框是否显示
                validationInfoShow: false,  //控制校验信息表格是否显示
                showViewFlag: "card",       //控制数据是否展开显示 card：卡片  table：表格

                // 待上传文件列表
                fileList: [],// 估价单上传
                //查询参数
                search: {
                    estimateNo: "",         //估价单号
                    containerNo: "",        //箱号
                    depotCode: "",          //堆场
                    createTimeStart: "",     //创建时间从
                    createTimeEnd: "",       //创建时间到
                },
                showNoDataView: false,
                tableCustomerChargeData: [],      // 第三方收退费查询结果
                tableImportValidation: [],        // 导入文件校验信息
                pageCount: 5,
                pageNum: 1,
                pageSize: 20,
                total: 0,
                fileImport : new FormData(),
                filePicBatchImport: new FormData(),
                uploadValidate: true,

                tableToolbar: {
                    perfect: true,
                    zoom: true,
                    custom: true,
                    slots: {
                        buttons: 'toolbar_buttons'
                    }
                },

                tableColumn: [
                    { align: 'center' ,type: 'seq', title: 'booking.no', width: 60, sortable: true, },//序号
                    { align: 'center' ,field: 'estimateNo', title: 'thirdPartyCharge.estimateNo', minWidth: 120, sortable: true,
                        slots: {
                            default: 'column_estimateNo'
                        }
                    },//估价单号
                    { align: 'center' ,field: 'containerNo', title: 'thirdPartyCharge.containerNo', minWidth: 130, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_containerNo'
                        }
                    },//箱号
                    { align: 'center' , field: 'depotCode', title: 'thirdPartyCharge.depotCode', minWidth: 120, sortable: true,
                        slots: {
                            default: 'column_depotCode'
                        }
                    },//堆场代码
                    { align: 'center' ,field: 'senderCode', title: 'thirdPartyCharge.senderCode', minWidth: 120, sortable: true,
                        slots: {   //该处展示自定义插槽，可以将数据封装到想用的组件里，视觉效果更佳
                            default: 'column_senderCode'
                        }
                    },//发送方代码
                    { align: 'center' ,field: 'currency', title: 'thirdPartyCharge.currency', minWidth: 130, sortable: true,  },//币种
                    { align: 'center' ,field: 'receiveDate', title: 'thirdPartyCharge.receiveDate', minWidth: 120, sortable: true,},//收费日期
                    { align: 'center' ,field: 'receiveAmount', title: 'thirdPartyCharge.receiveAmount', minWidth: 180, sortable: true, },//收费金额
                    { align: 'center' ,field: 'refundDate', title: 'thirdPartyCharge.refundDate', minWidth: 120, sortable: true, },//退费日期
                    { align: 'center' ,field: 'refundAmount', title: 'thirdPartyCharge.refundAmount', minWidth: 140, sortable: true, },//退费金额
                    { align: 'center' ,field: 'actualAmount', title: 'thirdPartyCharge.actualAmount', minWidth: 140, sortable: true, },//实际金额
                    { align: 'center' ,field: 'remark', title: 'thirdPartyCharge.remark', minWidth: 180 },//收退费说明
                    { align: 'center' ,field: 'createdDtmLoc', title: 'thirdPartyCharge.createdDtmLoc', minWidth: 110, sortable: true,},//创建时间
                ]
            };
        },
        methods: {
            handleViewStyle(data){
                // 切换展示风格
                this.showViewFlag = data.value;
                // 将展示风格存到session中
                localStorage.setItem("VIEW_STYLE",this.showViewFlag);
            },
            /**
             * 表格数据导出
             */
            exportDataEvent () {
                this.$refs.tableCustomerChargeData.openExport({ types: ['csv'] })
            },

            formatNumber(number, decimals) {
                if (number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0];
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                }
            },
            /************************************ 按钮点击事件 ***********************************
             * 第三方收退费查询 按钮点击
             */
            searchBtnClick() {
                if (this.isSearchClick) {//上一次查询未结束时不允许重复发起请求
                    return;
                }
                this.isSearchClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),     // 加载动画的文字
                    spinner: 'el-icon-loading',             // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    // target: document.querySelector(".searchComposite") // 设置加载动画区域
                });
                let that = this;
                this.axios({
                    method: 'post',
                    url: '/api/equipment/estimateCustomerChargeQuery',
                    data: {
                        estimateNo: this.search.estimateNo,
                        containerNo: this.search.containerNo,
                        depotCode: this.search.depotCode,
                        createTimeStart: this.search.createTimeStart === "" ? "" : this.formatDate(
                            {date: this.search.createTimeStart, formatStr: 'yyyy-MM-dd'}
                        ),
                        createTimeEnd: this.search.createTimeEnd === "" ? "" : this.formatDate(
                            {date: this.search.createTimeEnd, formatStr: 'yyyy-MM-dd'}
                        ),
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    that.loadingtuo.close();
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.showNoDataView = false;//请求成功,无数据组件隐藏,显示第三方收退费数据表格
                        this.tableCustomerChargeData = response.data.object.list;
                        this.total = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        // 当前未登录，跳转到登录页面
                        this.$router.push({
                            path: '/homePage',
                            query: {redirect: "/thirdPartyCharge"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                        });
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                }).catch(error => {
                    that.loadingtuo.close();//关闭进度条
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isSearchClick = false;//设置查询按钮为可点击状态,允许再次发起请求
                });
            },
            resetBtnClick() {//重置按钮点击
                this.search.estimateNo = "";
                this.search.containerNo = "";
                this.search.depotCode = "";
                this.search.createTimeStart = "";
                this.search.createTimeEnd = "";
            },
            editBtnClick(estimate) {//编辑按钮点击事件
            },
            /**
             * 第三方收退费导入
             */
            customerChargeExcelImport(){
                this.customerChargeUploadShow = true;
            },
            /**
             * 【第三方收退费导入】上传文件
             */
            uploadFile(){
                this.fileImport = new FormData();
                this.$refs.customerChargeUpload.submit();

                if(!this.uploadValidate){
                    return;
                }

                // 上传确认
                this.$confirm(this.$t("common.uploadConfirm"), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.confirmButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    this.validationInfoShow = false;
                    this.tableImportValidation = [];

                    if(!!this.fileImport.entries().next().value){
                        // 启动进度条
                        this.loadingOverLay = this.$loading({
                            lock: false,
                            text: this.$t('thirdPartyCharge.validating'),
                            spinner: 'el-icon-loading',
                            background: 'rgba(0,0,0,0.1)'
                        });
                        // 实现多文件同时上传
                        this.axios.post('/api/equipment/customerChargeUpload', this.fileImport, {
                            headers: {'Content-Type': 'multipart/form-data','Accept-language': localStorage.getItem("locale")},
                            timeout: 200000,
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            this.tableImportValidation = response.data.object;
                            this.validationInfoShow = true;
                            if (response.data.backCode === "200") {
                            } else {
                                this.showMessage(false, this.responseCode, "error");
                                // 当前未登录，跳转到登录页面
                                this.$router.push({
                                    path: '/homePage',
                                    query: {redirect: "/thirdPartyCharge"} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                                });
                            }
                            setTimeout(()=>{
                                this.loadingOverLay.close();
                            },500);
                        }).catch(error => {
                            if (error.data) {
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                            this.loadingOverLay.close();
                        });
                        // 上传完毕，清空文件存储列表
                        this.fileImport = new FormData();
                    }else{
                        this.showMessage(false, this.$t('estimate.pleaseSelectFiles2Upload'), "warning");
                    }
                });
            },
            // 第三方收退费上传自定义方法
            handleUpload(param){
                // 校验文件格式
                let reg = /(?<=\.)[a-z]+$/g;
                let fileType = param.file.name.match(reg)+"";
                let typeArr = ["xls","xlsx"];
                if(!typeArr.includes(fileType)){
                    this.$message.warning(this.$t('estimate.wrongEstimateFormat'));
                    this.uploadValidate = false;
                    return;
                }

                // 校验文件大小
                let fileSize = this.formatNumber(param.file.size / 1024 / 1024, 2);
                const isLt20M = fileSize < 20;
                if(!isLt20M){
                    this.$message.warning(this.$t('estimate.uploadSizeLimit',{fileName: param.file.name, fileSize : (fileSize+'M')}));
                    this.uploadValidate = false;
                    return;
                }

                this.fileImport.append('file',param.file);
            },
            /*
             *上传成功-回调函数
             */
            uploadSuccess(res, file, fileList){
                // 清除上传文件列表
                this.$refs.customerChargeUpload.clearFiles();
            },
            /**
             * 上传弹框关闭事件
             */
            handleClose(done){
                // 弹框关闭前，清空待上传文件列表
                this.fileList = [];
                this.tableImportValidation = [];
                this.validationInfoShow = false;
                    done();
            },

            /************************************ 分页条 ************************************
             * 第三方收退费数据表格分页条
             */
            handleDemand() {
                this.searchBtnClick();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleDemand();
                this.$emit("backTop");
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.handleDemand(1);
                this.$emit("backTop");
            },
            /**
             * 第三方收退费数据表格分页条(表格视图)
             */
            handleTablePageChange ({ currentPage, pageSize }) {
                this.pageNum = currentPage;
                this.pageSize = pageSize;
                this.searchBtnClick();
            },

            /************************************ 行记录点击事件 ************************************/

            /************************************ 基础数据下拉框赋值 ************************************/

            /************************************ 页面初始化 ************************************/

            /************************************ 接口返回数据国际化显示 *************************************/
            getCurLanguage() {
                return localStorage.getItem('locale');
            },
        },
        mounted() {
            // 页面渲染完成后初始化数据展示风格
            if(localStorage.getItem("VIEW_STYLE") != null){
                this.showViewFlag = localStorage.getItem("VIEW_STYLE");
            } else{
                this.showViewFlag = "card";//默认展示卡片视图
            }
        },
        created() {
            this.$parent.updateHeaderAside();
        },
        activated() {
            // //当估价单表格有数据时需自动查询最新数据
            // if (this.tableCustomerChargeData.length > 0) {
            //     this.searchBtnClick();
            // }
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    /*列表展示*/
    .contentListCom{min-height: 264px;}
    .contentListCom .oneContent{width: 100%;margin-bottom: 10px;margin-top: 5px;}
    .contentListCom .top{height: 40px;border: 1px solid #E8E8E8;background: #E9E9E9;padding-left: 18px;line-height: 40px;}
    .contentListCom .center{padding: 15px 0 15px 17px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none}
    .contentListCom .bottom{height: 40px;border: 1px solid #E8E8E8;background: #FFFFFF;border-top: none;line-height: 40px;}
    .contentListCom .listContentLong{width: 330px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContentShort{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent{width: 250px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #606266;margin-top: 5px;}
    .contentListCom .listContent .thirdSpan{margin-left: 5px;display: inline-block}
    .contentListCom .center .listContent{font-size: 15px;height: 20px;line-height: 20px;}
    .contentListCom .center .listContent .secondSpan{color: #031B28;}
    .contentListCom .center .shortListContent{width: 200px}
    .contentListCom .center .longListContent{width: 300px}
    .contentListCom .listContent.rightMoney{text-align: right;margin-right: 5px}
    /*列表展示的单选和费用明细按钮*/
    .contentListCom .top{position: relative}
    .contentListCom .top .evaluateBtn{margin-left: 10px;border-radius: 4px}
    .contentListCom .top .feeDetail{position: absolute;right: 5px;top: 5px}
    .contentListCom .top .checkOne{margin-right: 5px;margin-top: 5px}
    /*列表展示图标位置*/
    .contentListCom .center{position: relative}
    .typeImg{ width: 160px;height: 125px;position: absolute;right: 10px;top: 6px;}
    .flexDiv{display: flex;flex-wrap: wrap;}
    /*列表展示协议价订单等内容展示*/
    .leftMessage .msg{line-height: 39px;margin-left: 10px;color: #606266;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
    .xyj{width: 72px;color: #BC1920!important;}
    .auditMes{max-width: 95px;}
    .documentValid{width: 210px;margin-top: 5px;font-weight: bold}
    .documentValidLong{width: 280px;margin-top: 5px;font-weight: bold}
    .flexDiv .normalListButton{margin-right: 3px;}
    .flexDiv .normalListButton1{margin-right: 3px;margin-top: 2px}
    .flexDiv .normalListBlueButton{margin-right: 3px;background: $colorJ;color: $colorA;border: 1px solid #F6F6F6;}
    .flexDiv .normalListRedButton{margin-right: 3px;background: $colorC;color: $colorA;border: 1px solid #F6F6F6;}
    .hasBack{background-color: #567E8D;color: #fff}
    .hasBack:hover{background-color: #354953!important;color: #fff!important;}

    /*其他常用*/
    .visCom{visibility: hidden}
    .overflow{overflow: hidden}
    .l{float: left}
    .r{float: right}
    .flexDiv{display: flex;flex-wrap: wrap;}

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .el-upload{
        .el-upload-dragger{
            width: 700px;
        }
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontC;
            color: $colorF;
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .my-upload-demo ::v-deep .el-upload {
        .el-upload-dragger {
            background-color: #fff;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            box-sizing: border-box;
            width: 800px;
            height: 180px;
            text-align: center;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
    }

</style>